(function(angular) {
    THF.Angular.JoinForm.directive('vbox', function() {
        return {
            link: function(scope, element, attrs) {
                attrs.$observe('vbox', function(value) {
                    if(value === "") {
                        
                    }
                    element.get(0).setAttribute('viewBox', value);
                })
            }
        };
    });
})(angular);